export enum ReferenciaItem {
    "produto" = "produto",
    "entrega" = "entrega",
    "item" = "item"
}